import { type Color } from '@mui/material'

export const dhlRed = {
  100: '#230C0D',
  200: '#3A0B0E',
  300: '#670A0E',
  400: '#93090F',
  500: '#C00710',
  600: '#ED0611',
  700: '#F24049',
  800: '#F46A70',
  900: '#F6AFB2',
} satisfies Partial<Color>
